var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"elevation":"1"}},[_c('v-toolbar',{attrs:{"flat":"","rounded":"","color":"secondary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("FAILURES")))])],1),_c('div',{staticClass:"pa-4"},[_c('FailureList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }